/**
 * 결과를 모르는 되돌리기(응답 유실·결과 미확인·잠금 충돌)의 요청 키를 원 적용 job 기준으로 10분간 기억한다.
 * 확인 창을 취소했다 다시 열어도 같은 적용이면 **같은 키**로 보내 서버가 첫 결과를 재생하게 한다
 * (새 키면 두 번째 REVERT job 이 생겨 보통 「0건」으로 끝나 결과를 오인한다).
 * 관용구는 `features/ticketTransfer/pendingStore.ts` 와 같다 — sessionStorage, 접근이 막히면 조용히 기억하지 않는다.
 */
export const PENDING_REVERT_TTL_MS = 10 * 60 * 1000;
const PREFIX = 'rappo:settlementCategoryBulk:pendingRevert:';

type Stored = { requestId: string; savedAt: number };

const storage = (): Storage | null => {
    try {
        return typeof window !== 'undefined' ? window.sessionStorage : null;
    } catch {
        return null;
    }
};

const keyOf = (centerId: string, templateId: string, applyJobId: string) => `${PREFIX}${centerId}:${templateId}:${applyJobId}`;

export const savePendingRevert = (
    { centerId, templateId, applyJobId, requestId }: { centerId: string; templateId: string; applyJobId: string; requestId: string },
    now: number = Date.now(),
) => {
    const store = storage();
    if (!store || !centerId || !templateId || !applyJobId || !requestId) return;
    try {
        store.setItem(keyOf(centerId, templateId, applyJobId), JSON.stringify({ requestId, savedAt: now }));
    } catch {
        // 무시
    }
};

export const loadPendingRevert = (
    { centerId, templateId, applyJobId }: { centerId: string; templateId: string; applyJobId: string },
    now: number = Date.now(),
): string | null => {
    const store = storage();
    if (!store || !applyJobId) return null;
    const key = keyOf(centerId, templateId, applyJobId);
    try {
        const raw = store.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as Stored;
        const valid =
            parsed &&
            typeof parsed.requestId === 'string' &&
            typeof parsed.savedAt === 'number' &&
            now - parsed.savedAt >= 0 &&
            now - parsed.savedAt < PENDING_REVERT_TTL_MS;
        if (!valid) {
            store.removeItem(key);
            return null;
        }
        return parsed.requestId;
    } catch {
        return null;
    }
};

export const clearPendingRevert = ({ centerId, templateId, applyJobId }: { centerId: string; templateId: string; applyJobId: string }) => {
    const store = storage();
    if (!store) return;
    try {
        store.removeItem(keyOf(centerId, templateId, applyJobId));
    } catch {
        // 무시
    }
};
